export default function NavigationToggle() {
  const navbarToggler = document.querySelector(".navbar-toggler");
  navbarToggler.addEventListener("click", function() {
    const navbar = document.querySelector(navbarToggler.dataset.target);
    navbar.classList.toggle("collapse");
  });
}
